import React, { useState, useEffect, useRef } from 'react';
import RenderModalApplication from './RenderModalApplication';
import { motion } from 'framer-motion';
import { opacityAnimation } from './../Animation/Animation';
import { useSelector } from 'react-redux';

const OrderCatalogButton = (props) => {
    const { modalType } = useSelector((state) => state.application);

    const [showModal, setShowModal] = useState(false);
    const rootEl = useRef(null);

    useEffect(() => {
        if (!showModal) {
            return undefined;
        }

        const onClick = (event) => {
            if (!rootEl.current) {
                return;
            }

            if (!rootEl.current.contains(event.target)) {
                setShowModal(false);
            }
        };

        document.addEventListener('click', onClick);

        return () => document.removeEventListener('click', onClick);
    }, [showModal]);

    const handleClick = () => {
        if (typeof props.onClick === "function") {
            props.onClick();
            return;
        }

        setShowModal(true);
    };

    if (props.whiteBackground) {
        return (
            <>
                <motion.button
                    type="button"
                    initial="hidden"
                    viewport={{ amount: 0.3, once: true }}
                    whileInView="visible"
                    variants={opacityAnimation}
                    className="orderCatalog-white"
                    onClick={handleClick}
                    ref={rootEl}
                >
                    <motion.span>
                        {props.text}
                    </motion.span>
                </motion.button>

                <RenderModalApplication
                    showModal={showModal}
                    setShowModal={setShowModal}
                />
            </>
        );
    }

    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            className="orderCatalogWrap"
        >
            <button
                type="button"
                className="orderCatalog"
                onClick={handleClick}
                ref={rootEl}
            >
                <span>
                    {props.text}
                </span>
            </button>

            <RenderModalApplication
                modalType={modalType === "password" ? "password" : ""}
                showModal={showModal}
                setShowModal={setShowModal}
            />
        </motion.div>
    );
};

export default OrderCatalogButton;